import { useReadonlyField } from 'components/common-form/contexts/readonly/FieldMetadataContext';
import { FormattedMessage } from 'components/shared/Intl';
import { ScheduleGridValueDefinition } from 'models/metadata/readonlyValue.definition';
import { FC } from 'react';

import type { ProductSummaryCellMetadata } from './Schedule.model';
import { ProductSummaryScheduleRows } from './ScheduleRows';

interface ScheduleComponentProps {
  node: ScheduleGridValueDefinition;
}

export const ScheduleComponent: FC<ScheduleComponentProps> = ({ node }) => {
  const columns = node.columns as ProductSummaryCellMetadata[];
  const scheduleRows = useReadonlyField().getMetadataWithData(node);

  return (
    scheduleRows && (
      <table className="table table-striped">
        <thead>
          <tr>
            {columns.map((name, index) => (
              <th key={`${name}-${index}`}>
                <FormattedMessage id={`form.${name.id}` as any} defaultMessage={`${name.id}`} />
              </th>
            ))}
          </tr>
        </thead>
        <ProductSummaryScheduleRows scheduleRows={scheduleRows} metadata={columns} />
      </table>
    )
  );
};

ScheduleComponent.displayName = 'ProductSummaryScheduleField';
